import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/payments/visa.png")